const config = {
  apiKey: "AIzaSyDkbOQjPi0VJhakT-GFYK0zLnpxujxmJBY",
  authDomain: "learning-a4a51.firebaseapp.com",
  databaseURL: "https://learning-a4a51.firebaseio.com",
  projectId: "learning-a4a51",
  storageBucket: "learning-a4a51.appspot.com",
  messagingSenderId: "744969238443",
  appId: "1:744969238443:web:7b36aa0f149a14d79484ee",
  measurementId: "G-XQZJF1S3QR"
};

export default config
